// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__tCyyw","marketplaceColoredText":"SectionHero_marketplaceColoredText__6NXzJ","description":"SectionHero_description__r0hii"};